module.exports = __webpack_public_path__ + "static/media/seamoscomunidad.765dc5cd.png";